import React, { useEffect, useRef, useState } from "react";
import ChartComp from "../components/chart/Chart";
import { toast } from "react-toastify";
import { getBollingerBandsData, getCandlestickData } from "../utils/api";
import { initialValue, saveStateToLocalStorage } from "../utils/localstorage";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../components/Loader";

const BuyChart = (symbol) => {
  const [setting, setSetting] = useState(initialValue);
  const [data, setData] = useState([]);
  const [gridSetting, setGridSetting] = useState({
    style: "ShortDot",
    opacity: "0.1",
    strokeWidth: "2",
    grid: false,
  });
  const [indicatorConfig, setIndicatorConfig] = useState([]);
  const [candleStick, setCandleStick] = useState([]);
  const [loader, setloader] = useState(false);
  const drawingCanva = useRef();
  const [error, seterror] = useState("");

  const [isWidth, setISWidth] = useState(window.innerWidth < 890);
  useEffect(() => {
    setISWidth(window.innerWidth < 890);
  }, [window.innerWidth]);

  const checkForMobileDevice = () => {
    return /Mobi|Android/i.test(window.navigator.userAgent);
  };

  useEffect(() => {
    if (checkForMobileDevice()) {
      setSetting({ ...setting, isMobile: true });
    } else {
      setSetting({ ...setting, isMobile: false });
    }
  }, []);

  const fetchCandlestickData = async () => {
    const candlestickParams = {
      symbol: symbol.symbol ? symbol.symbol : symbol,
      startDate: new Date().toISOString().split("T")[0],
      period: "day",
    };
    try {
      setloader(true);
      const data = await getCandlestickData(
        ...Object.values(candlestickParams)
      );
      setCandleStick(data);
    } catch (error) {
      setSetting(initialValue);
      setCandleStick([]);
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      setloader(false);
      console.error(
        "Error fetching Candlestick data:",
        error.response.data.error || error.message
      );
    }
  };

  useEffect(() => {
    if (symbol?.symbol) {
      fetchCandlestickData();
    }
  }, [symbol?.symbol]);

  useEffect(() => {
    try {
      if (Object.keys(candleStick).length > 0) {
        const mergedResponse = candleStick.Date.map((date, index) => {
          return {
            date: new Date(date),
            open: candleStick.Open[index],
            high: candleStick.High[index],
            low: candleStick.Low[index],
            close: candleStick.Close[index],
            volume: candleStick.Volume[index],
            chart: [],
          };
        });
        setData(mergedResponse);
        setloader(false);
      }
    } catch (error) {
      seterror(
        error?.message ? "Something went wrong; please refresh the screen" : ""
      );
      setloader(false);
      console.error("Error occured while getting correct formate", error);
    }
  }, [candleStick]);

  useEffect(() => {
    saveStateToLocalStorage(setting);
  }, [setting]);

  return (
    <>
      {loader ? <Loader /> : ""}
      {data.length > 0 ? (
        <>
          <div className="grow shrink relative top-4" id="chart-container">
            <ChartComp
              initialData={data}
              setting={setting}
              padding={{ left: 0, right: 15 }}
              indicatorConfig={indicatorConfig}
              drawingCanva={drawingCanva}
              gridSetting={gridSetting}
              setSetting={setSetting}
              setIndicatorConfig={setIndicatorConfig}
            />
          </div>
        </>
      ) : (
        <div className="w-full flex justify-center flex-col items-center h-screen">
          {/* <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-8 w-8"></div> */}
          <p></p>
          {error && (
            <>
              <p>Error: {error}</p>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default BuyChart;
